export const getMaxNestingLevelGroups = (data, currentLevel = 0) => {
  if (!Array.isArray(data)) return currentLevel;
  let maxLevel = currentLevel;
  
  data.forEach(item => {
    if (item.title && Array.isArray(item.items)) {
      const nestedLevel = getMaxNestingLevelGroups(item.items, currentLevel + 1);
      maxLevel = Math.max(maxLevel, nestedLevel);
    } else if (Array.isArray(item)) {
      const nestedLevel = getMaxNestingLevelGroups(item, currentLevel);
      maxLevel = Math.max(maxLevel, nestedLevel);
    }
  });
  
  return maxLevel;
};

export const getMaxNestingLevelWBS = (data, currentLevel = 0) => {
  if (!Array.isArray(data)) return currentLevel;
  let maxLevel = currentLevel;
  
  data.forEach(item => {
    const itemLevel = item.level || currentLevel;
    maxLevel = Math.max(maxLevel, itemLevel);
    
    if (item.items && Array.isArray(item.items)) {
      const nestedLevel = getMaxNestingLevelWBS(item.items, itemLevel + 1);
      maxLevel = Math.max(maxLevel, nestedLevel);
    }
  });
  
  return maxLevel;
};